/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const teamCreateBodyDescriptionOneMax = 2000;

export const TeamCreateBody = zod.object({
  name: zod.string(),
  description: zod
    .union([zod.string().max(teamCreateBodyDescriptionOneMax), zod.null()])
    .optional(),
});

export type TeamCreateBody = zod.input<typeof TeamCreateBody>;
export type TeamCreateBodyOutput = zod.output<typeof TeamCreateBody>;
